import Header from "components/Headers/Header";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CardImg,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Button,
  Label,
  Input,
} from "reactstrap";
import ImageModal from "utils/ImageModal";
import { getWebtoonById, deleteWebtoonComment } from "utils/endpoint";
import { Modal } from "antd";
import { toast } from "react-toastify";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { RiDeleteBin6Line } from "react-icons/ri";
import { getAuthorSummaryById } from "utils/endpoint";
import { getUniverseSummaryById } from "utils/endpoint";
import { getIllustratorSummaryById } from "utils/endpoint";
import UniverseModal from "utils/universeModal";
import AuthorModal from "utils/authorModal";
import IllustratorModal from "utils/illustratorModal";
import Checkbox from "@mui/material/Checkbox";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import { handleWebtoonBookMark } from "./WebtoonList";
import isPageReload from "utils/enums";
import RatingUserListModal from "utils/ratingUserListModal";
import WebtoonPreview from "utils/webtoonPreviewModal";
import { useReactToPrint } from "react-to-print";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

function ViewWebtoonPrintSelection() {
  const { state } = useLocation();
  const [webtoon, setWebtoon] = useState(state.row);
  const [show, setShowModal] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [currentComment, setCurrentComment] = useState(state.row.comment);
  const [currentLoggedInUser, setCurrentLoggedInUser] = useState({});
  const [universeSummaryData, setUniverseSummaryData] = useState([]);
  const [illustratorSummaryData, setIllustratorSummaryData] = useState([]);
  const [authorSummaryData, setAuthorSummaryData] = useState([]);
  const [openUniverseModel, setOpenUniverseModel] = useState(false);
  const [openAuthorModel, setOpenAuthorModel] = useState(false);
  const [openIllustratorModel, setOpenIllustratorModel] = useState(false);
  const [image, setImage] = useState("");
  const [openUserRatingListModel, setOpenUserRatingListModel] = useState(false);
  const [ratingType, setRatingType] = useState("");
  const [ratingInfo, setRatingInfo] = useState([]);
  const [webtoonPrintSelections, setWebtoonPrintSelections] = useState({
    en_title: false,
    universe_name: false,
    jp_title: false,
    kr_title: false,
    status_name: false,
    no_of_volumes: false,
    ongoing: false,
    type_name: false,
    jp_platform: false,
    kr_platform: false,
    fr_platform: false,
    us_platform: false,
    jp_platform_likes: false,
    kr_platform_likes: false,
    fr_platform_likes: false,
    us_platform_likes: false,
    kr_wikipedia_link: false,
    jp_wikipedia_link: false,
    scantrad: false,
    low_sales: false,
    medium_sales: false,
    high_sales: false,
    fr_consumer_price: false,
    product_pl: false,
    jp_raw: false,
    created_at: false,
    cover_image: false,
    authors: false,
    genres: false,
    publics: false,
    illustrators: false,
    rating: false,
    comment: false,
    all_comments: false,
    user_first_name: false,
    user_last_name: false,
  });

  const [webtoonPreviewData, setWebtoonPreviewData] = useState({});
  const [selectWebtoonkeys, setSelectWebtoonKeys] = useState([
    'en_title',
    'universe_name',
    'jp_title',
    'kr_title',
    'status_name',
    'no_of_volumes',
    'ongoing',
    'type_name',
    'jp_platform',
    'kr_platform',
    'fr_platform',
    'us_platform',
    'jp_platform_likes',
    'kr_platform_likes',
    'fr_platform_likes',
    'us_platform_likes',
    'kr_wikipedia_link',
    'jp_wikipedia_link',
    'jp_raw',
    'scantrad',
    'low_sales',
    'medium_sales',
    'high_sales',
    'fr_consumer_price',
    'product_pl',
    'created_at',
    'cover_image',
    'authors',
    'genres',
    'publics',
    'illustrators',
    'rating',
    'comment'
  ]);

  const componentRef = useRef();

  const navigate = useNavigate();

  const { confirm } = Modal;
  const webtoonId = state.row.id;

  const handleDeleteWebtoonComment = async () => {
    try {
      setCurrentComment("");
      const response = await deleteWebtoonComment(webtoonId);
      if (response.isSuccess) {
        toast.success(`${response.message}`);
      }
    } catch (error) {
      setCurrentComment(state.row.comment);
      toast.error(`${error.message}`);
    }
  };

  const fetchUniverseDetail = async (unvierseId) => {
    setOpenUniverseModel(true);
    const res = await getUniverseSummaryById(unvierseId);

    if (res && res.isSuccess) {
      setUniverseSummaryData(res.data);
    }
  };

  const fetchAuthorsDetail = async (authorId) => {
    setOpenAuthorModel(true);
    const res = await getAuthorSummaryById(authorId);
    if (res && res.isSuccess) {
      setAuthorSummaryData(res.data);
    }
  };

  const fetchIllustratorDetail = async (illustratorId) => {
    setOpenIllustratorModel(true);
    const res = await getIllustratorSummaryById(illustratorId);
    if (res && res.isSuccess) {
      setIllustratorSummaryData(res.data);
    }
  };

  const showDeleteConfirm = () => {
    confirm({
      title: "Are you sure delete this comment ?",
      icon: <ExclamationCircleFilled />,
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        handleDeleteWebtoonComment();
      },
    });
  };

  useEffect(() => {
    const loginData = JSON.parse(localStorage.getItem("User"));
    if (loginData) {
      setPermissions(loginData.permissions);
      setCurrentLoggedInUser(loginData.user);
    }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const response = await getWebtoonById({
          webtoon_id: webtoonId,
        });
        if (response && response.isSuccess) {
          setCurrentComment(response.data.comment);
        }
      } catch (error) {
        toast.error(`${error.message}`);
      }
    })();
  }, []);

  useEffect(() => {
    setWebtoon(state.row);
  }, [state.row]);

  const handleOnChangePrintSelections = async (e, key) => {
    const isChecked = e.target.checked;

    if (isChecked && key) {
      webtoonPrintSelections[key] = isChecked;
    }

    if (!isChecked && key) {
      webtoonPrintSelections[key] = isChecked;
    }
  };

  const handlePrint = useReactToPrint({
    documentTitle:
      webtoon.en_title.toLowerCase() + moment().format("YYYY-MM-DD hh:mm:ss"),
    content: () => componentRef.current,
  });

  const handleWebtoonPrintSelectionalPreview = async () => {
    let webtoonSelectedData = {};
    for (const w in webtoon) {
      if (webtoonPrintSelections[w]) {
        webtoonSelectedData[w] = webtoon[w];
      }
    }

    if (webtoonPrintSelections.comment) {
      webtoonSelectedData.all_comments = webtoon["all_comments"];
      webtoonSelectedData.user_first_name = currentLoggedInUser.first_name;
      webtoonSelectedData.user_last_name = currentLoggedInUser.last_name;
    }
    if (webtoonPrintSelections.rating) {
      webtoonSelectedData.rating_one_counts = webtoon["rating_one_counts"];
      webtoonSelectedData.rating_two_counts = webtoon["rating_two_counts"];
      webtoonSelectedData.rating_three_counts = webtoon["rating_three_counts"];
    }

    if (Object.keys(webtoonSelectedData).length < 1) {
      toast.error("Please select the content you want to print.");
      return;
    }

    setWebtoonPreviewData(webtoonSelectedData);
  };

  const handleSelectAllCheckBox = async() => {
    for (const key of selectWebtoonkeys) {
      const targetCheckBox = document.getElementById(`${key}`);
      if(targetCheckBox && targetCheckBox !== null || undefined) targetCheckBox.checked = true;
      webtoonPrintSelections[key] = true;
    }

  }

  const handleUnselectAllCheckBox = async() => {
    for (const key of selectWebtoonkeys) {
      const targetCheckBox = document.getElementById(`${key}`);
    if(targetCheckBox && targetCheckBox !== null || undefined) targetCheckBox.checked = false;
      webtoonPrintSelections[key] = false;
    }
  }

  useEffect(() => {
    const isLength = Object.keys(webtoonPreviewData).length;
    if (isLength > 0) {
      handlePrint();
    }
  }, [webtoonPreviewData]);

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Card>
          <Row>
            <Col lg="7">
              <Card className="shadow m-4 detail_card">
                <CardHeader className="border-0">
                  <Row>
                    <Col lg="5">
                      {" "}
                      <h1 className="mb-0">
                        {" "}
                        Webtoon Detail
                        <Checkbox
                          {...label}
                          icon={<BookmarkBorderIcon />}
                          checkedIcon={<BookmarkIcon />}
                          defaultChecked={
                            webtoon?.bookmark_id !== null ? true : false
                          }
                          onClick={(e) =>
                            handleWebtoonBookMark({
                              isChecked: e.target.checked,
                              webtoonId: webtoon?.id,
                            })
                          }
                        />
                      </h1>
                    </Col>
                    <Col lg="7" className="add_btn text-right">
                      <Button
                        color="primary"
                        onClick={handleSelectAllCheckBox}
                      >
                        Select All
                      </Button>

                      <Button
                        color="primary"
                        onClick={handleUnselectAllCheckBox}
                      >
                        Deselect All
                      </Button>
                      <Button
                        color="primary"
                        onClick={handleWebtoonPrintSelectionalPreview}
                      >
                        Print Preview
                      </Button>

                      <Button
                        color="primary"
                        className="m-2"
                        onClick={() => navigate(-1)}
                      >
                        <span className="me-2">Back</span>
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody className="custom-margin-top">
                  <Row>
                    {webtoon?.en_title ? (
                      <>
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="en_title"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(e, "en_title")
                            }
                          />
                          <Label>EN Title</Label>
                        </Col>
                        <Col lg="8">
                          <div className="text-dark h2">{webtoon.en_title}</div>
                        </Col>
                      </>
                    ) : (
                      ""
                    )}
                  </Row>

                  <Row className="mt-1">
                    {webtoon?.universe_name ? (
                      <>
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="universe_name"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(e, "universe_name")
                            }
                          />
                          <Label>Universe Name</Label>
                        </Col>
                        <Col lg="8">
                          <span
                            className="primary-text-color"
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              fetchUniverseDetail(webtoon.universe_id)
                            }
                          >
                            {webtoon?.universe_name}
                          </span>
                        </Col>
                      </>
                    ) : (
                      ""
                    )}
                  </Row>
                  <Row className="mt-1">
                    {webtoon?.jp_title ? (
                      <>
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="jp_title"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(e, "jp_title")
                            }
                          />
                          <Label>JP Title</Label>
                        </Col>
                        <Col lg="8">
                          <span className="text-dark">{webtoon?.jp_title}</span>
                        </Col>
                      </>
                    ) : (
                      ""
                    )}
                  </Row>

                  <Row className="mt-1">
                    {webtoon?.kr_title ? (
                      <>
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="kr_title"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(e, "kr_title")
                            }
                          />
                          <Label>KR Title</Label>
                        </Col>
                        <Col lg="8">
                          <span className="text-dark">{webtoon?.kr_title}</span>
                        </Col>
                      </>
                    ) : (
                      ""
                    )}
                  </Row>

                  {webtoon?.status_name ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="status_name"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(e, "status_name")
                            }
                          />
                          <Label>Status</Label>
                        </Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {webtoon?.status_name}
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  {webtoon?.no_of_volumes ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="no_of_volumes"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(e, "no_of_volumes")
                            }
                          />
                          <Label>No. of chpt</Label>
                        </Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {webtoon?.no_of_volumes}
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  {webtoon?.ongoing ||
                  (!webtoon?.ongoing && webtoon?.ongoing !== null) ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="ongoing"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(e, "ongoing")
                            }
                          />
                          <Label>Ongoing</Label>
                        </Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {webtoon.ongoing === true ? "Yes" : "No"}
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  {webtoon?.type_name ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="type_name"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(e, "type_name")
                            }
                          />
                          <Label>Type</Label>
                        </Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {webtoon?.type_name}
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  {webtoon?.jp_platform ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="jp_platform"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(e, "jp_platform")
                            }
                          />
                          <Label>JP Platform</Label>
                        </Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {webtoon?.jp_platform}
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  {webtoon?.kr_platform ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="kr_platform"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(e, "kr_platform")
                            }
                          />
                          <Label>KR Platform</Label>
                        </Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {webtoon?.kr_platform}
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  {webtoon?.fr_platform ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="fr_platform"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(e, "fr_platform")
                            }
                          />
                          <Label>FR Platform</Label>
                        </Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {webtoon?.fr_platform}
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  {webtoon?.us_platform ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="us_platform"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(e, "us_platform")
                            }
                          />
                          <Label>US Platform</Label>
                        </Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {webtoon?.us_platform}
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  {webtoon?.jp_platform_likes ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="jp_platform_likes"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(
                                e,
                                "jp_platform_likes"
                              )
                            }
                          />
                          <Label>JP Platform Likes</Label>
                        </Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {webtoon?.jp_platform_likes}
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  {webtoon?.kr_platform_likes ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="kr_platform_likes"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(
                                e,
                                "kr_platform_likes"
                              )
                            }
                          />
                          <Label>KR Platform Likes</Label>
                        </Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {webtoon?.kr_platform_likes}
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  {webtoon?.fr_platform_likes ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="fr_platform_likes"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(
                                e,
                                "fr_platform_likes"
                              )
                            }
                          />
                          <Label>FR Platform Likes</Label>
                        </Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {webtoon?.fr_platform_likes}
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  {webtoon?.us_platform_likes ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="us_platform_likes"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(
                                e,
                                "us_platform_likes"
                              )
                            }
                          />
                          <Label>US Platform Likes</Label>
                        </Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {webtoon?.us_platform_likes}
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  {webtoon?.jp_wikipedia_link ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="jp_wikipedia_link"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(
                                e,
                                "jp_wikipedia_link"
                              )
                            }
                          />
                          <Label>JP Wikipedia</Label>
                        </Col>
                        <Col lg="8">
                          <div className="link primary-text-color">
                            <a
                              href={webtoon?.jp_wikipedia_link}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {webtoon?.jp_wikipedia_link?.length > 50
                                ? `${webtoon?.jp_wikipedia_link.slice(
                                    0,
                                    40
                                  )}...`
                                : webtoon?.jp_wikipedia_link}
                            </a>
                          </div>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  {webtoon?.kr_wikipedia_link ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="kr_wikipedia_link"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(
                                e,
                                "kr_wikipedia_link"
                              )
                            }
                          />
                          <Label>KR Wikipedia</Label>
                        </Col>
                        <Col lg="8">
                          <div className="link primary-text-color">
                            <a
                              href={webtoon?.kr_wikipedia_link}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {webtoon?.kr_wikipedia_link?.length > 50
                                ? `${webtoon?.kr_wikipedia_link.slice(
                                    0,
                                    40
                                  )}...`
                                : webtoon?.kr_wikipedia_link}
                            </a>
                          </div>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  {webtoon?.jp_raw ? (
                      <>
                        <Row className="mt-1">
                          <Col lg="4" className="d-flex align-items-center px-5">
                            <Input
                              id="jp_raw"
                              type="checkbox"
                              className="mb-3"
                              onChange={(e) =>
                                handleOnChangePrintSelections(e, "jp_raw")
                              }
                            />
                            <Label>JP Raw</Label>
                          </Col>
                          <Col lg="8">
                            <span className="text-dark">
                              {webtoon?.jp_raw}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}

                  {webtoon?.scantrad ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="scantrad"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(e, "scantrad")
                            }
                          />
                          <Label>ScanTrad</Label>
                        </Col>
                        <Col lg="8">
                          <div className="link primary-text-color">
                            <a
                              href={webtoon?.scantrad}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {webtoon?.scantrad?.length > 50
                                ? `${webtoon?.scantrad.slice(0, 40)}...`
                                : webtoon?.scantrad}
                            </a>
                          </div>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  {permissions &&
                    permissions.map((permission) =>
                      permission === "view-webtoon-low-sale" ? (
                        <>
                          {webtoon?.low_sales ? (
                            <Row className="mt-1">
                              <Col
                                lg="4"
                                className="d-flex align-items-center px-5"
                              >
                                <Input
                                  id="low_sales"
                                  type="checkbox"
                                  className="mb-3"
                                  onChange={(e) =>
                                    handleOnChangePrintSelections(
                                      e,
                                      "low_sales"
                                    )
                                  }
                                />
                                <Label>Low Sales</Label>
                              </Col>
                              <Col lg="8">
                                <span className="text-dark">
                                  {webtoon?.low_sales}
                                </span>
                              </Col>
                            </Row>
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        ""
                      )
                    )}

                  {permissions &&
                    permissions.map((permission) =>
                      permission === "view-webtoon-medium-sale" ? (
                        <>
                          {webtoon?.medium_sales ? (
                            <>
                              <Row className="mt-1">
                                <Col
                                  lg="4"
                                  className="d-flex align-items-center px-5"
                                >
                                  <Input
                                    id="medium_sales"
                                    type="checkbox"
                                    className="mb-3"
                                    onChange={(e) =>
                                      handleOnChangePrintSelections(
                                        e,
                                        "medium_sales"
                                      )
                                    }
                                  />
                                  <Label>Medium Sales</Label>
                                </Col>
                                <Col lg="8">
                                  <span className="text-dark">
                                    {webtoon?.medium_sales}
                                  </span>
                                </Col>
                              </Row>
                            </>
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        ""
                      )
                    )}

                  {permissions &&
                    permissions.map((permission) =>
                      permission === "view-webtoon-high-sale" ? (
                        <>
                          {webtoon?.high_sales ? (
                            <>
                              <Row className="mt-1">
                                <Col
                                  lg="4"
                                  className="d-flex align-items-center px-5"
                                >
                                  <Input
                                    id="high_sales"
                                    type="checkbox"
                                    className="mb-3"
                                    onChange={(e) =>
                                      handleOnChangePrintSelections(
                                        e,
                                        "high_sales"
                                      )
                                    }
                                  />
                                  <Label>High Sales</Label>
                                </Col>
                                <Col lg="8">
                                  <span className="text-dark">
                                    {webtoon?.high_sales}
                                  </span>
                                </Col>
                              </Row>
                            </>
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        ""
                      )
                    )}

                  {webtoon?.fr_consumer_price ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="fr_consumer_price"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(
                                e,
                                "fr_consumer_price"
                              )
                            }
                          />
                          <Label>FR Consumer Price</Label>
                        </Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {webtoon?.fr_consumer_price}
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  {permissions &&
                    permissions.map((permission) =>
                      permission === "view-webtoon-product-pl" ? (
                        <>
                          {webtoon?.product_pl ? (
                            <>
                              <Row className="mt-1">
                                <Col
                                  lg="4"
                                  className="d-flex align-items-center px-5"
                                >
                                  <Input
                                    id="product_pl"
                                    type="checkbox"
                                    className="mb-3"
                                    onChange={(e) =>
                                      handleOnChangePrintSelections(
                                        e,
                                        "product_pl"
                                      )
                                    }
                                  />
                                  <Label>Product P&L</Label>
                                </Col>
                                <Col lg="8">
                                  <span className="link primary-text-color text-wrap">
                                    <a
                                      href={webtoon?.product_pl}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {webtoon?.product_pl?.length > 50
                                        ? `${webtoon?.product_pl.slice(
                                            0,
                                            40
                                          )}...`
                                        : webtoon?.product_pl}
                                    </a>
                                  </span>
                                </Col>
                              </Row>
                            </>
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        ""
                      )
                    )}

                  {webtoon?.created_at ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4" className="d-flex align-items-center px-5">
                          <Input
                            id="created_at"
                            type="checkbox"
                            className="mb-3"
                            onChange={(e) =>
                              handleOnChangePrintSelections(e, "created_at")
                            }
                          />
                          <Label>CreatedAt</Label>
                        </Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {webtoon.created_at
                              ? moment(webtoon.created_at).format(
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              : ""}
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}
                </CardBody>
              </Card>
            </Col>
            <Col lg="2" className="columns"></Col>
            <Col lg="3">
              <Card className="text-right shadow m-4 view_cards">
                <CardBody>
                  {webtoon?.cover_image ? (
                    <>
                      <Input
                        id="cover_image"
                        type="checkbox"
                        className="mb-5"
                        onChange={(e) =>
                          handleOnChangePrintSelections(e, "cover_image")
                        }
                      />
                      <CardImg
                        src={webtoon?.cover_image}
                        width="180"
                        height="200"
                        alt="Upload"
                        className="overflow-hidden"
                        onClick={async () => {
                          setShowModal(true);
                          setImage(webtoon.cover_image);
                        }}
                      />
                    </>
                  ) : (
                    <CardImg
                      src={require("../../../assets/images/no-image.png")}
                      width="180"
                      height="200"
                      alt="Upload"
                      className=" overflow-hidden"
                      onClick={async () => {
                        setShowModal(true);
                        setImage(
                          require("../../../assets/images/no-image.png")
                        );
                      }}
                    />
                  )}
                </CardBody>
              </Card>
              <Card className="text-left shadow m-4 view_cards">
                <CardBody>
                  <Input
                    id="rating"
                    type="checkbox"
                    className="mb-3"
                    onChange={(e) => handleOnChangePrintSelections(e, "rating")}
                  />
                  <h4>Ratings</h4>

                  <div className="d-inline-flex">
                    <div>
                      <img
                        src={`${process.env.PUBLIC_URL}/rating-images/1.jpg`}
                        alt="rating-1"
                        style={{ width: "30%" }}
                      />
                      <span
                        className={`m-1 ${
                          webtoon?.rating_one_counts !== "0"
                            ? "primary-text-color cursor-pointer"
                            : ""
                        }`}
                        onClick={() => {
                          if (webtoon?.rating_one_counts !== "0") {
                            setRatingType(1);
                            setRatingInfo(webtoon);
                            setOpenUserRatingListModel(true);
                          }
                        }}
                      >
                        {webtoon?.rating_one_counts || 0}
                      </span>
                    </div>

                    <div className="pe-auto">
                      <img
                        src={`${process.env.PUBLIC_URL}/rating-images/2.jpg`}
                        alt="rating-2"
                        style={{ width: "30%" }}
                      />
                      <span
                        className={`m-1 ${
                          webtoon?.rating_two_counts !== "0"
                            ? "primary-text-color cursor-pointer"
                            : ""
                        }`}
                        onClick={() => {
                          if (webtoon?.rating_two_counts !== "0") {
                            setRatingType(2);
                            setRatingInfo(webtoon);
                            setOpenUserRatingListModel(true);
                          }
                        }}
                      >
                        {webtoon?.rating_two_counts || 0}
                      </span>
                    </div>

                    <div>
                      <img
                        src={`${process.env.PUBLIC_URL}/rating-images/3.jpg`}
                        alt="rating-3"
                        style={{ width: "27%" }}
                      />
                      <span
                        className={`m-2 ${
                          webtoon?.rating_three_counts !== "0"
                            ? "primary-text-color cursor-pointer"
                            : ""
                        }`}
                        onClick={() => {
                          if (webtoon?.rating_three_counts !== "0") {
                            setRatingType(3);
                            setRatingInfo(webtoon);
                            setOpenUserRatingListModel(true);
                          }
                        }}
                      >
                        {webtoon?.rating_three_counts || 0}
                      </span>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            {webtoon?.authors.length ? (
              <Col lg="4">
                <Card className=" shadow m-4 view_cards">
                  <CardBody>
                    <Input
                      id="authors"
                      type="checkbox"
                      className="mb-3"
                      onChange={(e) =>
                        handleOnChangePrintSelections(e, "authors")
                      }
                    />
                    <h3 className="fw-bolder dot_border">Authors</h3>
                    <Col>
                      {webtoon.authors.map((author, index) => (
                        <li
                          className="primary-text-color"
                          style={{ cursor: "pointer" }}
                          onClick={() => fetchAuthorsDetail(author.id)}
                          key={index}
                        >
                          {author.name}
                        </li>
                      ))}
                    </Col>
                  </CardBody>
                </Card>
              </Col>
            ) : (
              ""
            )}
            {webtoon?.authors.length ? <Col lg="2"></Col> : ""}
            {webtoon?.genres.length ? (
              <Col lg="4">
                <Card className="me-2 shadow m-4 view_cards">
                  <CardBody>
                    <Input
                      id="genres"
                      type="checkbox"
                      className="mb-3"
                      onChange={(e) =>
                        handleOnChangePrintSelections(e, "genres")
                      }
                    />
                    <h3 className="fw-bolder dot_border">Genre</h3>
                    <Col>
                      {webtoon.genres.map((genre, index) => (
                        <li key={index}>{genre.name}</li>
                      ))}
                    </Col>
                  </CardBody>
                </Card>
              </Col>
            ) : (
              ""
            )}
            {webtoon?.illustrators.length ? (
              <Col lg="4">
                <Card className=" shadow m-4 view_cards">
                  <CardBody>
                    <Input
                      id="illustrators"
                      type="checkbox"
                      className="mb-3"
                      onChange={(e) =>
                        handleOnChangePrintSelections(e, "illustrators")
                      }
                    />
                    <h3 className="fw-bolder dot_border">Illustrator</h3>
                    <Col>
                      {webtoon.illustrators.map((illustrators, index) => (
                        <li
                          className="primary-text-color"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            fetchIllustratorDetail(illustrators.id)
                          }
                          key={index}
                        >
                          {illustrators.name}
                        </li>
                      ))}
                    </Col>
                  </CardBody>
                </Card>
              </Col>
            ) : (
              ""
            )}
            {webtoon?.illustrators.length ? <Col lg="2"></Col> : ""}

            {webtoon?.publics.length ? (
              <Col lg="4">
                <Card className="me-2 shadow m-4 view_cards">
                  <CardBody>
                    <Input
                      id="publics"
                      type="checkbox"
                      className="mb-3"
                      onChange={(e) =>
                        handleOnChangePrintSelections(e, "publics")
                      }
                    />
                    <h3 className="fw-bolder dot_border">Public</h3>
                    <Col>
                      {webtoon.publics.map((publicsD, index) => (
                        <li key={index}>{publicsD.name}</li>
                      ))}
                    </Col>
                  </CardBody>
                </Card>
              </Col>
            ) : (
              ""
            )}
          </Row>
          <Row>
            <Col lg="12">
              <Card className="me-2 shadow m-4 ">
                <CardBody>
                  {currentComment || webtoon.all_comments.length > 0 ? (
                    <Input
                      id="comment"
                      type="checkbox"
                      className="mb-3"
                      onChange={(e) =>
                        handleOnChangePrintSelections(e, "comment")
                      }
                    />
                  ) : (
                    ""
                  )}

                  <h3 className="fw-bolder dot_border">Comments</h3>
                  {currentComment || webtoon.all_comments ? (
                    <>
                      <Row>
                        {currentComment ? (
                          <Col lg="3">
                            <Card className=" shadow mt-2 ">
                              <CardHeader className="h4">
                                {currentLoggedInUser.first_name}{" "}
                                {currentLoggedInUser.last_name}
                                <RiDeleteBin6Line
                                  onClick={showDeleteConfirm}
                                  className="ml-7"
                                  style={{ cursor: "pointer" }}
                                  size={26}
                                  color="#e62a2e"
                                />
                              </CardHeader>
                              <CardBody>{currentComment}</CardBody>
                            </Card>
                          </Col>
                        ) : (
                          ""
                        )}
                        {webtoon?.all_comments?.length > 0
                          ? webtoon.all_comments.map((x) => (
                              <>
                                <Col lg="3">
                                  <Card className="shadow mt-2 ">
                                    <CardHeader className="h4">
                                      {x.first_name} {x.last_name}
                                    </CardHeader>
                                    <CardBody>{x.comment}</CardBody>
                                  </Card>
                                </Col>
                              </>
                            ))
                          : ""}
                      </Row>
                    </>
                  ) : (
                    "No Comments"
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ImageModal
            show={show}
            image={image}
            onClose={() => {
              setShowModal(false);
            }}
          />
          <UniverseModal
            openUniverseModel={openUniverseModel}
            setOpenUniverseModel={setOpenUniverseModel}
            universeSummaryData={universeSummaryData}
            currentWebtoonId={webtoonId}
            isPageReload={isPageReload.WEBTOON}
            isLinkFunctionalityActive={true}
          />
          <AuthorModal
            openAuthorModel={openAuthorModel}
            setOpenAuthorModel={setOpenAuthorModel}
            authorSummaryData={authorSummaryData}
            currentWebtoonId={webtoonId}
            isPageReload={isPageReload.WEBTOON}
            isLinkFunctionalityActive={true}
          />
          <IllustratorModal
            openIllustratorModel={openIllustratorModel}
            setOpenIllustratorModel={setOpenIllustratorModel}
            illustratorSummaryData={illustratorSummaryData}
            currentWebtoonId={webtoonId}
            isPageReload={isPageReload.WEBTOON}
            isLinkFunctionalityActive={true}
          />
          <RatingUserListModal
            openUserRatingListModel={openUserRatingListModel}
            setOpenUserRatingListModel={setOpenUserRatingListModel}
            ratingInfo={ratingInfo}
            ratingType={ratingType}
            title="Webtoon Rating Details"
          />
          <div style={{ display: "none" }}>
            <WebtoonPreview
              ref={componentRef}
              webtoonPreviewData={webtoonPreviewData}
            />
          </div>
        </Card>
      </Container>
    </>
  );
}

export default ViewWebtoonPrintSelection;